import apiClient from '../../../services/apiClient';

class AdminService {
  // Get current user from localStorage
  getCurrentUser() {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  }

  // Get admin's tasks
  async getTasks() {
    try {
      const user = this.getCurrentUser();
      if (!user) {
        throw new Error('User not authenticated');
      }

      // For now, return mock data
      // In the future, this would call: `/api/v1/admin/${user.id}/tasks`
      return [
        { id: 1, text: 'Review System Performance Metrics', checked: false },
        { id: 2, text: 'Check Doctor Registration Applications', checked: false },
        { id: 3, text: 'Update User Access Permissions', checked: false },
        { id: 4, text: 'Review Monthly Analytics Report', checked: false },
        { id: 5, text: 'Monitor System Security Status', checked: false }
      ];
    } catch (error) {
      console.error('Error fetching tasks:', error);
      throw error;
    }
  }

  // Get admin's notifications
  async getNotifications() {
    try {
      const user = this.getCurrentUser();
      if (!user) {
        throw new Error('User not authenticated');
      }

      // For now, return mock data
      // In the future, this would call: `/api/v1/admin/${user.id}/notifications`
      return [
        { id: 1, text: 'New Doctor Registration - Dr. Michael Brown', checked: false },
        { id: 2, text: 'System Backup Completed Successfully', checked: false },
        { id: 3, text: 'Patient Data Export Request - Hospital A', checked: false },
        { id: 4, text: 'Security Alert - Multiple Failed Login Attempts', checked: false },
        { id: 5, text: 'Monthly Report Generated - June 2024', checked: false },
        { id: 6, text: 'New Clinic Registration - Metro Health', checked: false },
        { id: 7, text: 'System Maintenance Scheduled - Weekend', checked: false }
      ];
    } catch (error) {
      console.error('Error fetching notifications:', error);
      throw error;
    }
  }

  // Get latest news for admin
  async getLatestNews() {
    try {
      // For now, return mock data
      // In the future, this would call: `/api/v1/admin/news`
      return [
        {
          id: 1,
          title: 'Healthcare System Updates',
          excerpt: 'New updates to the healthcare management system have been deployed...',
          date: new Date().toISOString()
        },
        {
          id: 2,
          title: 'Security Enhancement Release',
          excerpt: 'Enhanced security features now available for all user accounts...',
          date: new Date().toISOString()
        },
        {
          id: 3,
          title: 'Performance Improvements',
          excerpt: 'System performance has been optimized for better user experience...',
          date: new Date().toISOString()
        }
      ];
    } catch (error) {
      console.error('Error fetching news:', error);
      throw error;
    }
  }

  // Get admin by user ID
  async getAdminByUserId(userId) {
    try {
      const response = await apiClient.get(`/admin/by-user/${userId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching admin by user ID:', error);
      // Return mock data for now
      return {
        id: 1,
        user_id: userId,
        first_name: 'Admin',
        last_name: 'User',
        email: 'admin@medifusion.com'
      };
    }
  }

  // Get admin bookings for a specific date
  async getAdminBookings(adminId, date) {
    try {
      const response = await apiClient.get(`/admin/${adminId}/bookings?date=${date}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching admin bookings:', error);
      // Return empty array for now
      return [];
    }
  }

  // Update task status
  async updateTaskStatus(taskId, checked) {
    try {
      const response = await apiClient.patch(`/admin/tasks/${taskId}`, { checked });
      return response.data;
    } catch (error) {
      console.error('Error updating task status:', error);
      // For now, just return success
      return { success: true };
    }
  }

  // Update notification status
  async updateNotificationStatus(notificationId, checked) {
    try {
      const response = await apiClient.patch(`/admin/notifications/${notificationId}`, { checked });
      return response.data;
    } catch (error) {
      console.error('Error updating notification status:', error);
      // For now, just return success
      return { success: true };
    }
  }

  // Get system statistics
  async getSystemStats() {
    try {
      const response = await apiClient.get('/admin/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching system stats:', error);
      // Return mock data for now
      return {
        totalUsers: 1250,
        totalDoctors: 45,
        totalPatients: 1180,
        totalClinicians: 25,
        todayAppointments: 67,
        pendingRegistrations: 8
      };
    }
  }

  // Get all users
  async getAllUsers() {
    try {
      const response = await apiClient.get('/admin/users');
      return response.data;
    } catch (error) {
      console.error('Error fetching all users:', error);
      throw error;
    }
  }

  // Get all doctors
  async getAllDoctors() {
    try {
      const response = await apiClient.get('/admin/doctors');
      return response.data;
    } catch (error) {
      console.error('Error fetching all doctors:', error);
      throw error;
    }
  }

  // Get all patients
  async getAllPatients() {
    try {
      const response = await apiClient.get('/admin/patients');
      return response.data;
    } catch (error) {
      console.error('Error fetching all patients:', error);
      throw error;
    }
  }

  // Get all clinicians
  async getAllClinicians() {
    try {
      const response = await apiClient.get('/admin/clinicians');
      return response.data;
    } catch (error) {
      console.error('Error fetching all clinicians:', error);
      throw error;
    }
  }
}

const adminService = new AdminService();
export default adminService;

